import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { format } from '@dt/fe-utils'
import { useHistoryNew, modalLayer } from '@utils'
import { Discount, CheckoutAddress } from '../../component'
import { IonContent, useIonViewWillEnter, useIonRouter, useIonViewWillLeave } from '@ionic/react'
import { decorationMobx, memberMobx } from '@mobxStore'
import { cartMobx, payPlanMobx, discountMobx, feeMobx } from 'mobx/mall'
import { Input, OpenCardSlides, CommonDetailModal } from '@cps'
import './index.scss'

interface IProps { }

const CartCheck: FC<IProps> = (props) => {
  const history = useHistoryNew()
  const ionicRoute = useIonRouter()
  const [remarkInfo, setRemarkInfo] = useState('')
  const cartResult = cartMobx.cartResult
  useIonViewWillEnter(() => {
    // 来自于订单页
    payPlanMobx.beginCalc()
    if (decorationMobx.tabBarVisible) {
      decorationMobx.setTabBarVisible(false)
      document.querySelector('ion-tab-bar')?.classList.add('hide')
    }
  })

  // 为了解决结算页不处理尚在购物车的餐品，给一个标记位，这个标记位用于标记是否处理已下单未下单混杂的情况，还是只显示已下单的餐品
  useIonViewWillLeave(() => {
    cartMobx.setIsMixture(true)
    payPlanMobx.endCalc()
  })

  const showServiceChageDetail = () => {
    const datas = cartResult.serviceChargeDetail.map(item => {
      const value = item.type === 'amount' ? format.toPrice(item.value) : item.value.toString() + '%'
      return {
        id: item.id,
        name: item.name,
        price: item.amount,
        tips: i18n.t(`checkout.service_charge_by_${item.type === 'person' ? 'person' : 'fixed'}_${item.type === 'amount' ? 'amount' : 'percent'}`, { value })
      }
    })
    modalLayer(CommonDetailModal, { datas, title: feeMobx.gratuityConfig?.name }, 'commonDetailModal')
      .then(() => { })
      .catch(() => { })
  }

  return (
    <>
      <IonContent className='mall-checkout-content'>
        <CheckoutAddress />
        {props.children}
        <>
          <div className='cart-box'>
            <div className='cart-box-info cart-box-item'>
              <div className='cart-item-left'>
                <p>{i18n.t('newCart.remark')}</p>
              </div>
              <Input
                className='cart-remark-input'
                maxLength={128}
                value={remarkInfo}
                placeholder={i18n.t('cart.remartplacechoder2')}
                onChange={(e: any) => { setRemarkInfo(e.target.value); cartMobx.setRemark(e.target.value) }}
              />
            </div>
            <div className='cart-box-info cart-box-item'>
              <div className='cart-item-left'>
                <p>{i18n.t('mall.productPrice')}</p>
              </div>
              <p className='cart-item-price'>{format.toPrice(cartResult.itemPrice)}</p>
            </div>
            {/* 运费费 */}
            {
              cartResult.expressPrice > 0 ? (
                <div className='cart-box-info cart-box-item'>
                  <div className='cart-item-left'>
                    <p>{i18n.t('result.expressPriceMall')}</p>
                  </div>
                  <div className='cart-item-price'>{format.toPrice(cartResult.expressPrice)}</div>
                </div>
              ) : null
            }
            <Discount />
            {
              window.bo !== 'cn' && (
                <div className='cart-box-info cart-box-item'>
                  <div className='cart-item-left'>
                    <p>{i18n.t('result.tax')}</p>
                  </div>
                  <div className='cart-item-price'>{format.toPrice(cartResult.tax || 0)}</div>
                </div>
              )
            }
            {/* 服务费 */}
            {
              cartResult.serviceCharge > 0 ? (
                <div className='cart-box-info cart-box-item'>
                  <div className='cart-item-left'>
                    <p>{feeMobx.gratuityConfig?.name}</p>
                    <i className='iconfont icon-question1' data-cypid='cartCheckShowServiceDetail' onClick={showServiceChageDetail}></i>
                  </div>
                  <div className='cart-item-price'>{format.toPrice(cartResult.serviceCharge || 0)}</div>
                </div>
              ) : null
            }
          </div>
          <div className='cart-pay-result'>
            <div className='cart-pay-box'>
              <div className='cart-pay-info'>
                <div className='actual-pay-amount'>
                  <span dangerouslySetInnerHTML={{ __html: i18n.t('cart.result', { totalCnt: cartResult.totalCnt, totalDiscountPrice: format.toPriceLittleCurrency(cartResult.totalDiscountPrice) }) }}></span>
                  <span className='amount' dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(payPlanMobx.totalAmount) }}></span>
                </div>
                {
                  memberMobx.isLogin && memberMobx.mallCardInfo?.card?.isIntegral && <div className='integral'>{i18n.t('cart.maybeGetIntegral', { count: discountMobx.discountResult.getIntegral })}</div>
                }
              </div>
            </div>
          </div>
        </>
        {
          memberMobx.noPurchasedCards?.length &&
            <div className='card-open-slides'>
              <OpenCardSlides type='mall' noPurchasedCardMap={discountMobx.discountResult.noPurchasedCardMap}></OpenCardSlides>
            </div>
        }
      </IonContent>
    </>
  )
}

export default observer(CartCheck)
